import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from '../../../utils/react/usePrevious';
import { fetchCmsData } from '../../../cms/cmsActions';
import { CmsEntities } from '../../../cms/cmsConstants';
import { getCurrentUserSegment } from '../../../user/currentUserSelector';
import { getCmsTemplatesFetched, getOnboardTemplateLandingPage } from '../boardTemplatePickerSelectors';

export const useCmsTemplateFetching = () => {
    const areTemplatesFetched = useSelector(getCmsTemplatesFetched);
    const currentUserSegment = useSelector(getCurrentUserSegment);
    const onboardingLandingPage = useSelector(getOnboardTemplateLandingPage);

    const prevUserSegment = usePrevious(currentUserSegment);
    const prevOnboardingLandingPage = usePrevious(onboardingLandingPage);

    const dispatch = useDispatch();
    const fetchTemplateCMSData = ({ segment, landingPage }: { segment: string; landingPage: string | null }) =>
        dispatch(
            fetchCmsData(
                CmsEntities.TEMPLATES,
                // Force fetching, because we're already preventing unnecessary fetches
                // in the useEffect
                true,
            )({
                segments: [segment],
                landingPage: landingPage ? landingPage : undefined,
            }),
        );

    useEffect(() => {
        const hasChangedSegmentProps =
            prevUserSegment !== currentUserSegment || prevOnboardingLandingPage !== onboardingLandingPage;

        const shouldFetchCMSData = !areTemplatesFetched || hasChangedSegmentProps;
        if (!shouldFetchCMSData) return;

        fetchTemplateCMSData({
            segment: currentUserSegment || '',
            landingPage: onboardingLandingPage,
        });
    }, [areTemplatesFetched, currentUserSegment, prevUserSegment, onboardingLandingPage, prevOnboardingLandingPage]);
};
